/** Display branding — storage keys (@hria/*, hria-prefs) stay unchanged. */
export const APP_FULL_NAME = 'Hizb-ur-Rehman Finance Management System';
export const APP_SHORT_NAME = 'Hizb-ur-Rehman';
export const APP_TAGLINE = 'Integrated Financial Operations';
